import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { GeckoFields, GECKO_UTILS, GECKO_CONSTS } from 'ui';
import tokenGenerator from '../../../../utilities/tokenGenerator';

class WeChatChannelForm extends Component {
  static propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,
  };
  static defaultProps = {
    onChange: () => {},
  };

  componentDidMount() {
    if (!this.props.value.configuration.token) {
      let newValue = GECKO_UTILS.setNestedValue(
        this.props.value,
        'configuration.token',
        tokenGenerator(32)
      );
      newValue = GECKO_UTILS.setNestedValue(
        newValue,
        'configuration.encodingAESKey',
        tokenGenerator(43)
      );
      this.props.onChange(newValue);
    }
  }

  changeHandler(key, value) {
    const newValue = GECKO_UTILS.setNestedValue(this.props.value, key, value);
    this.props.onChange(newValue);
  }

  fields = [
    {
      key: 'name',
      type: GECKO_CONSTS.FIELD_TYPE_TEXT,
      label: 'Channel Title',
      width: 'col-xs-12',
      required: true,
    },
    {
      key: 'configuration.token',
      type: GECKO_CONSTS.FIELD_TYPE_TEXT,
      label: 'WeChat Token',
      width: 'col-xs-12',
      // required: true,
      description:
        'Set the Token in your WeChat Developer Basic Configuration to this value.',
      disabled: true,
    },
    {
      key: 'configuration.encodingAESKey',
      type: GECKO_CONSTS.FIELD_TYPE_TEXT,
      label: 'WeChat EncodingAESKey',
      width: 'col-xs-12',
      // required: true,
      description:
        'Set the EncodingAESKey in your WeChat Developer Basic Configuration to this value.',
      disabled: true,
    },
    {
      key: 'configuration.wechat_username',
      type: GECKO_CONSTS.FIELD_TYPE_TEXT,
      label: 'WeChat ID (Original ID)',
      width: 'col-xs-12',
      required: true,
    },
    {
      key: 'configuration.app_id',
      type: GECKO_CONSTS.FIELD_TYPE_TEXT,
      label: 'App ID',
      width: 'col-xs-12',
      required: true,
    },
    {
      key: 'configuration.app_secret',
      type: GECKO_CONSTS.FIELD_TYPE_TEXT,
      label: 'App Secret',
      width: 'col-xs-12',
      required: true,
    },
    {
      key: 'configuration.server',
      type: GECKO_CONSTS.FIELD_TYPE_SELECT,
      label: 'What kind of Official Account do you have?',
      width: 'col-xs-12',
      options: [
        {
          label: 'Chinese Official Account (Weixin)',
          value: 'api.weixin.qq.com',
        },
        {
          label: 'International Official Account (WeChat)',
          value: 'api.wechat.com',
        },
      ],
      required: true,
    },
    {
      // potentially enable this if we want to use auto-reply messages
      key: 'configuration.auto_response',
      type: GECKO_CONSTS.FIELD_TYPE_TEXT,
      label: 'Auto Response',
      width: 'col-xs-12',
      description:
        'This reply will be sent to anyone who messages your WeChat official account.',
      hideWhen: () => true,
    },
  ];

  render() {
    return (
      <GeckoFields
        fields={this.fields}
        values={this.props.value}
        handler={this.changeHandler.bind(this)}
      />
    );
  }
}

export default WeChatChannelForm;
